/**
 * Short browser beep for trigger alerts (Web Audio API).
 */

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    const AC =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AC) return null;
    if (!ctx) ctx = new AC();
    return ctx;
  } catch {
    return null;
  }
}

/** Resume audio after a user gesture if the browser suspended the context. */
export function unlockAudio(): void {
  const c = getCtx();
  if (c?.state === "suspended") {
    void c.resume();
  }
}

export function playBeep(freq = 880, durationMs = 120, volume = 0.15): void {
  const c = getCtx();
  if (!c) {
    // Fallback: very short data-URI is unreliable; try oscillator only
    return;
  }
  void c.resume().then(() => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(c.destination);
    const t0 = c.currentTime;
    gain.gain.setValueAtTime(volume, t0);
    gain.gain.exponentialRampToValueAtTime(0.001, t0 + durationMs / 1000);
    osc.start(t0);
    osc.stop(t0 + durationMs / 1000 + 0.02);
  });
}
